import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsExclamationTriangleFill } from '@react-icons/all-files/bs/BsExclamationTriangleFill';
import './styles.scss';

export interface ErrorIconProps {
    message: string;
}

/**
 * Shared error icon component that displays a tooltip on hover or click.
 */
const ErrorIcon = ({ message }: ErrorIconProps) => (
    <OverlayTrigger
        trigger={['hover', 'click']}
        placement="top"
        rootClose
        overlay={<Tooltip className="rb-error-tooltip">{message}</Tooltip>}
    >
        <span className="rb-input-error-icon" role="img" aria-label={message}>
            <BsExclamationTriangleFill size={12} />
        </span>
    </OverlayTrigger>
);

export default ErrorIcon;